import { buildReducer } from '../../../../shared';
import type DeletePersonaState from '../../../state/deletePersonaState';
import {
    confirmDeletePersonasClickedAction,
    cancelDeletePersonasClickedAction,
} from '../../../actions/user/deleteDialogActions';
import { deletePersonasClickedAction } from '../../../actions/user/commandBarActions';
import { deletePersonasCompletedAction } from '../../../actions/data/deletePersonasActions';
import { deletePublicFolderPersonaCompletedAction } from '../../../actions/data/deletePublicFolderPersonaActions';

/**
 * Keeps track of personas being deleted
 */
export default buildReducer<DeletePersonaState>()
    .handle(deletePersonasClickedAction, (state, action) => ({
        ...state,
        showConfirmationDialog: true,
    }))
    .handle(cancelDeletePersonasClickedAction, (state, action) => ({
        ...state,
        showConfirmationDialog: false,
    }))
    .handle(confirmDeletePersonasClickedAction, (state, action) => ({
        ...state,
        personasBeingDeleted: state.personasBeingDeleted.concat(
            action.payload.deletedHubPersonaIds
        ),
        showConfirmationDialog: false,
    }))
    .handleDataAction(
        deletePersonasCompletedAction,
        (state, action) => ({
            ...state,
            personasBeingDeleted: state.personasBeingDeleted.filter(
                hubPersonaId => action.payload.deletedHubPersonaIds.indexOf(hubPersonaId) < 0
            ),
        }),
        (state, action) => ({
            ...state,
            personasBeingDeleted: state.personasBeingDeleted.filter(
                hubPersonaId => action.payload.deletedHubPersonaIds.indexOf(hubPersonaId) < 0
            ),
        })
    )
    .handleDataAction(
        deletePublicFolderPersonaCompletedAction,
        (state, action) => ({
            ...state,
            personasBeingDeleted: state.personasBeingDeleted.filter(
                id => id !== action.payload.deletedHubPersonaId
            ),
        }),
        (state, action) => ({
            ...state,
            personasBeingDeleted: state.personasBeingDeleted.filter(
                id => id !== action.payload.deletedHubPersonaId
            ),
        })
    )
    .done({ personasBeingDeleted: [], showConfirmationDialog: false });
export type { Action } from '../../../../shared';
